interface ScoreMeterProps {
  value: number;
  showValue?: boolean;
}

export function ScoreMeter({ value, showValue = true }: ScoreMeterProps) {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  return (
    <div className="bios-score-meter">
      <div className="bios-score-bar">
        <div className="bios-score-fill" style={{ width: `${pct}%` }} />
      </div>
      {showValue && (
        <span style={{ fontFamily: "var(--bios-mono)", fontSize: 12, minWidth: 38, textAlign: "right" }}>
          {pct.toFixed(0)}
        </span>
      )}
    </div>
  );
}
